if (!customElements.get('invoice-details')) {
  customElements.define(
    'invoice-details',
    class InvoiceDetails extends HTMLElement {
      constructor() {
        super();

        this.form = document.getElementById(this.dataset.form);
        this.details = this.querySelector('details');
        this.statusEl = this.querySelector('[data-invoice-status]');

        this.fields = {
          company: this.querySelector('[data-invoice-field="company"]'),
          business_id: this.querySelector('[data-invoice-field="business_id"]'),
          einvoice_address: this.querySelector('[data-invoice-field="einvoice_address"]'),
          einvoice_operator: this.querySelector('[data-invoice-field="einvoice_operator"]'),
          billing_email: this.querySelector('[data-invoice-field="billing_email"]'),
          reference: this.querySelector('[data-invoice-field="reference"]'),
        };
        this.methodRadios = Array.from(this.querySelectorAll('[data-invoice-field="method"]'));

        this.debouncedSave = this.debounce(this.saveToCart.bind(this), 500);

        this.methodRadios.forEach((radio) => {
          radio.addEventListener('change', () => {
            this.toggleMethodFields();
            this.saveToCart();
          });
        });

        this.addEventListener('input', (event) => {
          this.clearError(event.target);
          this.debouncedSave();
        });

        this.addEventListener(
          'change',
          (event) => {
            if (event.target.tagName === 'INPUT' && event.target.type !== 'radio') {
              this.saveToCart();
            }
          },
          true
        );

        if (this.form) {
          this.form.addEventListener('submit', this.onSubmit.bind(this));
        }

        this.toggleMethodFields();
      }

      debounce(fn, wait) {
        let timeout;
        return (...args) => {
          clearTimeout(timeout);
          timeout = setTimeout(() => fn(...args), wait);
        };
      }

      get selectedMethod() {
        const checked = this.methodRadios.find((radio) => radio.checked);
        return checked ? checked.value : null;
      }

      get isActive() {
        return !!(this.details && this.details.open);
      }

      toggleMethodFields() {
        const method = this.selectedMethod;

        this.querySelectorAll('[data-invoice-group="verkkolasku"]').forEach((group) => {
          group.hidden = method !== 'verkkolasku';
        });

        this.querySelectorAll('[data-invoice-group="sahkopostilasku"]').forEach((group) => {
          group.hidden = method !== 'sähköpostilasku';
        });
      }

      saveToCart() {
        if (!this.isActive) return;

        const method = this.selectedMethod;
        const attributes = {
          'Yritys tai seura': (this.fields.company?.value || '').trim(),
          'Y-tunnus': (this.fields.business_id?.value || '').trim(),
          Laskutustapa: method || '',
          Verkkolaskuosoite: (this.fields.einvoice_address?.value || '').trim(),
          'Verkkolaskun välittäjätunnus': (this.fields.einvoice_operator?.value || '').trim(),
          Laskutussähköposti: (this.fields.billing_email?.value || '').trim(),
          'Laskutusviite / kustannuspaikka': (this.fields.reference?.value || '').trim(),
        };

        this.setStatus('Tallennetaan…');

        fetch(routes.cart_update_url, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json',
          },
          body: JSON.stringify({ attributes }),
        })
          .then((response) => response.json())
          .then((cart) => {
            if (!cart || cart.errors) throw new Error('invoice-details save failed');
            this.setStatus('Laskutustiedot tallennettu.');
          })
          .catch(() => {
            this.setStatus('Tietojen tallennus epäonnistui. Yritä uudelleen.', true);
          });
      }

      setStatus(text, isError) {
        if (!this.statusEl) return;
        this.statusEl.textContent = text;
        this.statusEl.classList.toggle('invoice-details__status--error', !!isError);
      }

      onSubmit(event) {
        if (!this.isActive) return;

        const { valid, firstInvalid } = this.validateAll();

        if (!valid) {
          event.preventDefault();
          if (firstInvalid) {
            firstInvalid.focus();
            firstInvalid.scrollIntoView({ behavior: 'smooth', block: 'center' });
          }
        }
      }

      validateAll() {
        let valid = true;
        let firstInvalid = null;
        const method = this.selectedMethod;

        const required = [
          { key: 'company', el: this.fields.company },
          { key: 'business_id', el: this.fields.business_id },
        ];

        if (method === 'verkkolasku') {
          required.push({ key: 'einvoice_address', el: this.fields.einvoice_address });
          required.push({ key: 'einvoice_operator', el: this.fields.einvoice_operator });
        } else if (method === 'sähköpostilasku') {
          required.push({ key: 'billing_email', el: this.fields.billing_email });
        }

        required.forEach(({ key, el }) => {
          if (!el) return;
          if (!el.value.trim()) {
            this.showError(key, 'Tämä kenttä on pakollinen.');
            valid = false;
            if (!firstInvalid) firstInvalid = el;
          } else {
            this.clearError(el);
          }
        });

        if (method === 'sähköpostilasku' && this.fields.billing_email && this.fields.billing_email.value.trim()) {
          const emailOk = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(this.fields.billing_email.value.trim());
          if (!emailOk) {
            this.showError('billing_email', 'Tarkista sähköpostiosoitteen muoto.');
            valid = false;
            if (!firstInvalid) firstInvalid = this.fields.billing_email;
          }
        }

        return { valid, firstInvalid };
      }

      showError(key, message) {
        const errorEl = this.querySelector(`[data-invoice-error="${key}"]`);
        if (errorEl) errorEl.textContent = message;
        const fieldEl = this.fields[key];
        if (fieldEl) fieldEl.classList.add('invoice-details__input--error');
      }

      clearError(el) {
        if (!el || !el.dataset) return;
        const key = el.dataset.invoiceField;
        if (!key) return;
        const errorEl = this.querySelector(`[data-invoice-error="${key}"]`);
        if (errorEl) errorEl.textContent = '';
        el.classList.remove('invoice-details__input--error');
      }
    }
  );
}
